export default {
  id: '#section-1'
};



// WEBPACK FOOTER //
// ./src/js/section-1.js